import React from 'react'
import { Box, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { ContentFilterType, FilterType, TreeFilterType } from './types'
import { TypeSelect } from './TypeSelect'
import { BodyFilter } from './BodyFilter'
import { DescendantFilter } from './DescendantFilter'
import { ContentFilter } from './ContentFilter'

export function TreeFilter({
  onFilterChange,
  filter,
}: {
  onFilterChange(f: TreeFilterType): void
  filter: TreeFilterType
}) {
  const typeChange = ({ target: { value } }: SelectChangeEvent<FilterType>) => {
    if (typeof value === 'string') return
    onFilterChange({ filterType: value })
  }

  return (
    <Box>
      <Box>
        Filter Type{' '}
        <Select value={filter.filterType} onChange={typeChange}>
          <MenuItem value={FilterType.node}>Node</MenuItem>
          <MenuItem value={FilterType.leaf}>Leaf</MenuItem>
        </Select>
      </Box>
      <NodeOrLeafFilter filter={filter} onFilterChange={onFilterChange} />
    </Box>
  )
}

function NodeOrLeafFilter({
  filter,
  onFilterChange,
}: {
  filter: TreeFilterType
  onFilterChange: (f: TreeFilterType) => void
}) {
  const onContentChange = (withContent: ContentFilterType) => {
    onFilterChange({
      ...filter,
      withContent,
    })
  }

  return (
    <Box>
      <TypeSelect filter={filter} onFiltersChanged={onFilterChange} />
      <BodyFilter filter={filter} onFiltersChanged={onFilterChange} />
      <DescendantFilter filter={filter} onFiltersChanged={onFilterChange} />
      <ContentFilter
        onFiltersChanged={onContentChange}
        contentFilters={filter.withContent}
      />
    </Box>
  )
}
